/* Ghost Town Seeds SeedFinder
   Ohjattu lajikehaku. Ei riippuvuuksia; toimii standalone ja Shopify-teemassa. */
(function (global) {
  'use strict';

  /* ---------- Apurit ---------------------------------------------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; }

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
  var STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 5.87 6.48.94-4.69 4.57 1.11 6.45L12 17.77l-5.8 3.05 1.11-6.45L2.62 9.8l6.48-.94z"/></svg>';

  /* ---------- Kysymyskorttien ikonit ------------------------------------
     Ohutviivaiset custom-SVG:t, currentColor -> väri tulee CSS:stä. Sisältö
     inline, ei erillisiä tiedostoja (CSP-turvallista, toimii teemassa).    */
  var ICONS = {
    'experience-beginner': '<path d="M12 21 V11"/><path d="M12 11 C 12 7 14.5 5 18.5 5 C 18.5 9 16 11 12 11 Z"/>',
    'experience-some': '<path d="M12 21 V9"/><path d="M12 13 C 12 10 10 8 6.5 8 C 6.5 11.5 8.5 13 12 13 Z"/><path d="M12 11 C 12 8 14 6 17.5 6 C 17.5 9.5 15.5 11 12 11 Z"/>',
    'experience-expert': '<path d="M8 3 Q 16 12 8 21"/><path d="M16 3 Q 8 12 16 21"/><path d="M9.6 5 H14.4"/><path d="M11 8 H13"/><path d="M11 16 H13"/><path d="M9.6 19 H14.4"/>',
    'space-small': '<path d="M4 8 H20 V20 H4 Z"/><path d="M4 8 L6.5 4 H17.5 L20 8"/><path d="M12 8 V20"/>',
    'space-medium': '<path d="M2 20 H22"/><path d="M12 5 L2 20"/><path d="M12 5 L22 20"/><path d="M12 5 L9 20"/><path d="M12 5 L15 20"/>',
    'space-large': '<path d="M4 21 V10 L12 3 L20 10 V21 Z"/><path d="M9.5 21 V15 H14.5 V21"/>',
    'speed-fast': '<path d="M13 2 L4.5 13.5 H11 L10 22 L19.5 10.5 H13 Z"/>',
    'speed-balanced': '<path d="M12 5 V20"/><path d="M8 21 H16"/><path d="M4 7 H20"/><path d="M4 7 L2 12"/><path d="M4 7 L6 12"/><path d="M1.5 12 A 4 4 0 0 0 6.5 12"/><path d="M20 7 L18 12"/><path d="M20 7 L22 12"/><path d="M17.5 12 A 4 4 0 0 0 22.5 12"/>',
    'speed-yield': '<path d="M8 4 H16 V9 C16 12 14 13.5 12 13.5 C10 13.5 8 12 8 9 Z"/><path d="M8 5.5 H5 V7 C5 9 6.5 9.5 8 9.5"/><path d="M16 5.5 H19 V7 C19 9 17.5 9.5 16 9.5"/><path d="M12 13.5 V17"/><path d="M9 20 H15"/><path d="M11 17 L10 20"/><path d="M13 17 L14 20"/>',
    'character-relaxing': '<path d="M20 13 A 8 8 0 1 1 11 4 A 6 6 0 1 0 20 13 Z"/>',
    'character-energetic': '<circle cx="12" cy="12" r="4.5"/><path d="M12 1.5 V4"/><path d="M12 20 V22.5"/><path d="M4.2 4.2 L6 6"/><path d="M18 18 L19.8 19.8"/><path d="M1.5 12 H4"/><path d="M20 12 H22.5"/><path d="M4.2 19.8 L6 18"/><path d="M18 6 L19.8 4.2"/>',
    'character-balanced': '<circle cx="12" cy="12" r="9"/><path d="M12 3 V21"/>',
    'character-any': '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
    'yield-important': '<path d="M3 17 L9 11 L13 15 L21 7"/><path d="M15 7 H21 V13"/>',
    'yield-bonus': '<circle cx="12" cy="12" r="9"/><path d="M8.5 14 C 10 16 14 16 15.5 14"/><path d="M9 9.5 H9.01"/><path d="M15 9.5 H15.01"/>',
    'yield-notimportant': '<circle cx="12" cy="12" r="9"/><path d="M8 12 H16"/>',
    'aroma-citrus': '<path d="M3 7 H21"/><path d="M21 7 A 9 9 0 0 1 3 7"/><path d="M12 7 L5 9.5"/><path d="M12 7 L7.5 14.5"/><path d="M12 7 L12 16"/><path d="M12 7 L16.5 14.5"/><path d="M12 7 L19 9.5"/>',
    'aroma-sweet': '<path d="M12 8 C 6.5 8 5 12.5 7.5 16.5 C 9.5 19.5 14.5 19.5 16.5 16.5 C 19 12.5 17.5 8 12 8 Z"/><path d="M12 3 V6"/><path d="M8 5.5 L12 8 L16 5.5"/><path d="M9.5 11.5 H9.51"/><path d="M14.5 11.5 H14.51"/><path d="M12 14 H12.01"/>',
    'aroma-earthy': '<path d="M12 2 V4"/><path d="M5.5 8 C 5.5 5 8.5 4 12 4 C 15.5 4 18.5 5 18.5 8 Z"/><path d="M6.5 8 C 6.5 14 9 20 12 20 C 15 20 17.5 14 17.5 8"/>',
    'aroma-floral': '<circle cx="12" cy="10" r="1.8"/><circle cx="12" cy="5.6" r="2.6"/><circle cx="16.18" cy="8.64" r="2.6"/><circle cx="14.59" cy="13.56" r="2.6"/><circle cx="9.41" cy="13.56" r="2.6"/><circle cx="7.82" cy="8.64" r="2.6"/>'
  };
  function icon(name) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
  }

  /* ---------- Terpeeni -> aromikategoria -------------------------------- */
  var TERPENE_AROMA = {
    limonene: 'citrus', eucalyptol: 'pine', pinene: 'pine',
    ocimene: 'sweet', terpinolene: 'fruity',
    myrcene: 'earthy', humulene: 'earthy', caryophyllene: 'spicy',
    linalool: 'floral'
  };

  /* ---------- Normalisointi (yksi totuuden lähde) ----------------------- */
  function leanCat(strain) {
    var v = (strain.lean || '').toLowerCase();
    // Metafield "Indica/Sativa" on ensisijainen lähde.
    if (v.indexOf('hybrid') > -1 || v.indexOf('tasapain') > -1) return 'hybrid';
    if (v.indexOf('indica') > -1) return 'indica';
    if (v.indexOf('sativa') > -1) return 'sativa';
    // Varalta tageista.
    var tags = (strain.tags || []).join(' ').toLowerCase();
    if (tags.indexOf('indica') > -1) return 'indica';
    if (tags.indexOf('sativa') > -1) return 'sativa';
    return 'hybrid';
  }

  function yieldScore(strain) {
    var v = (strain.yield || '').toLowerCase();
    if (v.indexOf('erittäin runsas') > -1) return 4;
    if (v.indexOf('runsas') > -1) return 3;
    if (v.indexOf('keskikok') > -1) return 2;
    if (v.indexOf('pieni') > -1) return 1;
    // tageista
    var tags = (strain.tags || []).join(' ').toLowerCase();
    if (tags.indexOf('suuri sato') > -1) return 3;
    return 2;
  }

  // Palauttaa {min,max} viikkoina tai null.
  function parseWeeks(strain) {
    var candidates = (strain.tags || []).slice();
    if (strain.flowering) candidates.push(strain.flowering);
    var wk = null, day = null;
    for (var i = 0; i < candidates.length; i++) {
      var s = String(candidates[i]).toLowerCase();
      var mW = s.match(/(\d+)\s*(?:-|–)\s*(\d+)\s*viikk|(\d+)\s*viikk/);
      if (mW) {
        if (mW[1] && mW[2]) wk = mergeRange(wk, +mW[1], +mW[2]);
        else if (mW[3]) wk = mergeRange(wk, +mW[3], +mW[3]);
        continue;
      }
      var mD = s.match(/(\d+)\s*(?:-|–)\s*(\d+)\s*päiv|(\d+)\s*päiv/);
      if (mD) {
        if (mD[1] && mD[2]) day = mergeRange(day, mD[1] / 7, mD[2] / 7);
        else if (mD[3]) day = mergeRange(day, mD[3] / 7, mD[3] / 7);
      }
    }
    if (wk) return wk;
    if (day) return { min: Math.round(day.min), max: Math.round(day.max) };
    // Autoflowerin sanallinen elinkaari
    var f = (strain.flowering || '').toLowerCase();
    if (f.indexOf('alle 7-8') > -1) return { min: 7, max: 8 };
    if (f.indexOf('yli 8-9') > -1) return { min: 9, max: 10 };
    // bare "10-12"
    for (var j = 0; j < candidates.length; j++) {
      var b = String(candidates[j]).match(/^(\d+)\s*(?:-|–)\s*(\d+)$/);
      if (b) return { min: +b[1], max: +b[2] };
    }
    return null;
  }
  function mergeRange(cur, lo, hi) {
    if (!cur) return { min: lo, max: hi };
    return { min: Math.min(cur.min, lo), max: Math.max(cur.max, hi) };
  }

  function aromaSet(strain) {
    var set = {};
    String(strain.terpenes || '').split(',').forEach(function (t) {
      var key = t.trim().toLowerCase();
      var cat = TERPENE_AROMA[key];
      if (cat) set[cat] = true;
    });
    return set;
  }

  function hasAward(strain) {
    return (strain.tags || []).some(function (t) {
      var s = t.toLowerCase();
      return s.indexOf('voittaja') > -1 || s.indexOf('winner') > -1 || s === 'cup-voittaja';
    });
  }

  function normalize(strain) {
    var weeks = parseWeeks(strain);
    return {
      raw: strain,
      title: strain.title, handle: strain.handle, vendor: strain.vendor,
      image: strain.image, price: strain.price,
      available: strain.available !== false,
      type: strain.type === 'auto' ? 'auto' : 'photo',
      lean: leanCat(strain),
      yieldScore: yieldScore(strain),
      weeks: weeks,
      weeksAvg: weeks ? (weeks.min + weeks.max) / 2 : null,
      easy: (strain.tags || []).indexOf('Helppo') > -1,
      short: (strain.tags || []).some(function (t) { return t === 'Matala' || t === 'Lyhyt'; }),
      award: hasAward(strain),
      aromas: aromaSet(strain)
    };
  }

  var LEAN_LABEL = { indica: 'Indica', sativa: 'Sativa', hybrid: 'Hybridi' };
  var YIELD_LABEL = { 1: 'Pieni sato', 2: 'Keskisato', 3: 'Runsas sato', 4: 'Huippusato' };

  function speedFactor(n) {
    // 1 = erittäin nopea (6 vk), 0 = hidas (11 vk)
    if (n.weeksAvg == null) return n.type === 'auto' ? 0.6 : 0.4;
    return clamp((11 - n.weeksAvg) / (11 - 6), 0, 1);
  }
  function yieldFactor(n) { return (n.yieldScore - 1) / 3; } // 0..1

  /* ---------- Kysymykset ------------------------------------------------ */
  // score(answer, n) -> { p, max }  (max 0 = ei vaikuta prosenttiin)
  var QUESTIONS = [
    {
      id: 'experience',
      q: 'Kuinka hyvin tunnet kannabislajikkeet?',
      help: 'Suosittelemme selkeitä ja tunnettuja lajikkeita keräilyn aloitukseen.',
      options: [
        { value: 'aloittelija', icon: 'experience-beginner', label: 'Vasta-alkaja', sub: 'Uusi keräilijä' },
        { value: 'jonkin', icon: 'experience-some', label: 'Jonkin verran', sub: 'Muutama lajike tuttu' },
        { value: 'kokenut', icon: 'experience-expert', label: 'Konkari', sub: 'Tunnen genetiikat' }
      ],
      score: function (a, n) {
        var W = 1.5;
        if (a === 'aloittelija') return { p: n.easy ? W : (n.type === 'auto' ? W * 0.6 : 0), max: W };
        if (a === 'jonkin') return { p: n.easy ? W * 0.5 : 0, max: W * 0.5 };
        return { p: 0, max: 0 };
      }
    },
    {
      id: 'size',
      q: 'Minkä kokoista lajiketta etsit?',
      help: 'Kuvaa lajikkeen kasvutapaa ja kokoa (geneettinen ominaisuus).',
      options: [
        { value: 'kompakti', icon: 'space-small', label: 'Kompakti', sub: 'Matala, tilaa säästävä lajike' },
        { value: 'keskikokoinen', icon: 'space-medium', label: 'Keskikokoinen', sub: 'Tasapainoinen koko' },
        { value: 'suuri', icon: 'space-large', label: 'Suuri lajike', sub: 'Kookas, runsaskasvuinen' }
      ],
      score: function (a, n) {
        var W = 1.5;
        if (a === 'kompakti') return { p: clamp((n.short ? W * 0.6 : 0) + (n.type === 'auto' ? W * 0.4 : 0), 0, W), max: W };
        if (a === 'suuri') return { p: clamp((n.type === 'photo' ? W * 0.5 : 0) + (n.yieldScore >= 3 ? W * 0.5 : 0), 0, W), max: W };
        return { p: 0, max: 0 };
      }
    },
    {
      id: 'speed',
      q: 'Kumpi on sinulle tärkeämpää?',
      help: 'Nopea sato vai suurin mahdollinen tuotto?',
      options: [
        { value: 'nopea', icon: 'speed-fast', label: 'Nopea sato', sub: 'Valmista pian, kevyt aikataulu' },
        { value: 'tasapaino', icon: 'speed-balanced', label: 'Jotain siltä väliltä', sub: 'Ei kumpikaan ääripää' },
        { value: 'sato', icon: 'speed-yield', label: 'Suuri sato', sub: 'Odotan pidempään isommasta tuotosta' }
      ],
      score: function (a, n) {
        var W = 2.5;
        if (a === 'nopea') return { p: (n.type === 'auto' ? W * 0.5 : 0) + speedFactor(n) * W * 0.5, max: W };
        if (a === 'sato') return { p: (n.type === 'photo' ? W * 0.4 : 0) + yieldFactor(n) * W * 0.6, max: W };
        return { p: 0, max: 0 };
      }
    },
    {
      id: 'effect',
      q: 'Millaista luonnetta haet?',
      help: 'Lajikkeen indica/sativa-painotus ohjaa yleistä profiilia.',
      options: [
        { value: 'rentouttava', icon: 'character-relaxing', label: 'Rentouttava', sub: 'Rauhoittava, illan lajike (indica)' },
        { value: 'energinen', icon: 'character-energetic', label: 'Energinen', sub: 'Virkeä ja luova, päivän lajike (sativa)' },
        { value: 'tasapainoinen', icon: 'character-balanced', label: 'Tasapainoinen', sub: 'Molempia sopivasti (hybridi)' },
        { value: 'eivalia', icon: 'character-any', label: 'Ei väliä', sub: 'Näytä kaikki' }
      ],
      score: function (a, n) {
        var W = 3;
        if (a === 'rentouttava') return { p: n.lean === 'indica' ? W : (n.lean === 'hybrid' ? W * 0.4 : 0), max: W };
        if (a === 'energinen') return { p: n.lean === 'sativa' ? W : (n.lean === 'hybrid' ? W * 0.4 : 0), max: W };
        if (a === 'tasapainoinen') return { p: n.lean === 'hybrid' ? W : W * 0.35, max: W };
        return { p: 0, max: 0 };
      }
    },
    {
      id: 'yieldimp',
      q: 'Kuinka tärkeä suuri sato on?',
      help: 'Painottaa runsaammin tuottavia lajikkeita.',
      options: [
        { value: 'tarkea', icon: 'yield-important', label: 'Tärkeä', sub: 'Haluan mahdollisimman paljon' },
        { value: 'kiva', icon: 'yield-bonus', label: 'Kiva bonus', sub: 'Ei ratkaise, mutta plussaa' },
        { value: 'eivalia', icon: 'yield-notimportant', label: 'Ei tärkeä', sub: 'Muut asiat ratkaisevat' }
      ],
      score: function (a, n) {
        var W = 1.5;
        if (a === 'tarkea') return { p: yieldFactor(n) * W, max: W };
        if (a === 'kiva') return { p: yieldFactor(n) * W * 0.5, max: W * 0.5 };
        return { p: 0, max: 0 };
      }
    },
    {
      id: 'aroma',
      q: 'Mitkä maut ja aromit kiinnostavat?',
      help: 'Valitse yksi tai useampi. Perustuu lajikkeen pääterpeeneihin.',
      multi: true,
      options: [
        { value: 'citruspine', icon: 'aroma-citrus', label: 'Sitruksinen & raikas', sub: 'Limonene, pinene', cats: ['citrus', 'pine'] },
        { value: 'sweetfruity', icon: 'aroma-sweet', label: 'Makea & hedelmäinen', sub: 'Ocimene, terpinolene', cats: ['sweet', 'fruity'] },
        { value: 'earthyspicy', icon: 'aroma-earthy', label: 'Maanläheinen & mausteinen', sub: 'Myrcene, caryophyllene', cats: ['earthy', 'spicy'] },
        { value: 'floral', icon: 'aroma-floral', label: 'Kukkainen & yrttinen', sub: 'Linalool, humulene', cats: ['floral'] }
      ],
      score: function (a, n, opt) {
        // a = valittujen arvojen taulukko
        var W = 2;
        if (!a || !a.length) return { p: 0, max: 0 };
        var cats = {};
        a.forEach(function (val) {
          var o = opt.options.filter(function (x) { return x.value === val; })[0];
          if (o) o.cats.forEach(function (c) { cats[c] = true; });
        });
        var hit = Object.keys(n.aromas).some(function (c) { return cats[c]; });
        return { p: hit ? W : 0, max: W };
      }
    }
  ];

  /* ---------- Pisteytys & syyt ------------------------------------------ */
  function scoreStrain(n, answers) {
    var num = 0, den = 0;
    QUESTIONS.forEach(function (Q) {
      if (!(Q.id in answers)) return;
      var r = Q.score(answers[Q.id], n, Q);
      num += r.p; den += r.max;
    });
    var pct = den > 0 ? Math.round((num / den) * 100) : 70;
    return { pct: clamp(pct, 0, 100), num: num, den: den };
  }

  function reasons(n, answers) {
    var out = [];
    if (answers.experience === 'aloittelija' && n.easy) out.push('Aloittelijaystävällinen');
    if (answers.size === 'kompakti' && n.short) out.push('Kompakti kasvutapa');
    if (answers.size === 'suuri' && n.yieldScore >= 3) out.push('Runsaskasvuinen');
    if (answers.speed === 'nopea' && n.type === 'auto') out.push('Nopea autoflower');
    if (answers.speed === 'nopea' && n.weeksAvg != null && n.weeksAvg <= 8) out.push('Nopea kukinta');
    if (answers.speed === 'sato' && n.yieldScore >= 3) out.push('Suuri sato');
    if (answers.effect === 'rentouttava' && n.lean === 'indica') out.push('Rentouttava indica');
    if (answers.effect === 'energinen' && n.lean === 'sativa') out.push('Energinen sativa');
    if (answers.effect === 'tasapainoinen' && n.lean === 'hybrid') out.push('Tasapainoinen hybridi');
    if (answers.yieldimp === 'tarkea' && n.yieldScore >= 3) out.push('Korkea sato');
    if (answers.aroma && answers.aroma.length) {
      var Q = QUESTIONS.filter(function (x) { return x.id === 'aroma'; })[0];
      var cats = {};
      answers.aroma.forEach(function (val) {
        var o = Q.options.filter(function (x) { return x.value === val; })[0];
        if (o) o.cats.forEach(function (c) { cats[c] = true; });
      });
      var aromaNames = { citrus: 'Sitruksinen', pine: 'Raikas', sweet: 'Makea', fruity: 'Hedelmäinen', earthy: 'Maanläheinen', spicy: 'Mausteinen', floral: 'Kukkainen' };
      var picked = Object.keys(n.aromas).filter(function (c) { return cats[c]; });
      if (picked.length) out.push(aromaNames[picked[0]] + ' aromi');
    }
    if (n.award) out.push('Palkittu lajike');
    return out.slice(0, 3);
  }

  /* ---------- Widget ---------------------------------------------------- */
  function SeedFinderApp(root, strains, opts) {
    this.root = root;
    this.baseUrl = (opts.baseUrl || '').replace(/\/$/, '');
    this.resultsCount = opts.resultsCount || 6;
    this.data = strains.map(normalize);
    this.answers = {};
    this.multiSel = [];
    this.step = -1; // -1 = intro
    // Lukittu tyyppi (opts.typeFilter): kokoelmakohtainen sivu voi rajata widgetin
    // pysyvästi feminisoituihin ('photo') tai autoflowereihin ('auto'). Introssa ei
    // silloin näytetä tyyppivalintaa, ja "Aloita alusta" säilyttää rajauksen.
    this.lockType = (opts.typeFilter === 'photo' || opts.typeFilter === 'auto') ? opts.typeFilter : null;
    this.typeFilter = this.lockType; // null = kaikki, 'photo' = feminisoidut, 'auto' = autoflowerit
    this.onlyInStock = false;
    this.shown = null; // montako tulosta näytetään (null = oletus resultsCount)
    this.render();
  }

  SeedFinderApp.prototype.render = function () {
    this.root.className = 'seedfinder';
    if (this.step === -1) return this.renderIntro();
    if (this.step >= QUESTIONS.length) return this.renderResults();
    return this.renderStep();
  };

  SeedFinderApp.prototype.renderIntro = function () {
    var self = this;
    this.root.innerHTML = '';
    var wrap = el('<div class="sf-step sf-intro"></div>');
    wrap.innerHTML =
      '<div class="sf-head">' +
        '<h2 class="sf-title">Löydä täydellinen genetiikkasi</h2>' +
        '<p class="sf-sub">Vastaa muutamaan kysymykseen, niin ehdotamme sinulle parhaiten sopivat siemenet valikoimastamme.</p>' +
      '</div>' +
      '<div class="sf-intro-features">' +
        '<span><b>' + self.data.length + '</b>&nbsp;lajiketta</span>' +
        '<span>' + QUESTIONS.length + ' kysymystä</span>' +
        '<span>Henkilökohtaiset suositukset</span>' +
      '</div>' +
      '<div class="sf-intro-actions">' +
        (this.lockType ? '' : '<p class="sf-intro-choose">Mistä lajikkeista olet kiinnostunut?</p>') +
        '<div class="sf-intro-choices"></div>' +
      '</div>';
    // Aloitusvalinta toimii samalla tyyppisuodattimena (photo = feminisoidut).
    // Lukitulla tyypillä valintoja ei näytetä — vain yksi aloitusnappi.
    var choices = this.lockType
      ? [{ v: this.lockType, label: 'Aloita haku' }]
      : [
          { v: null, label: 'Kaikki' },
          { v: 'photo', label: 'Feminisoidut' },
          { v: 'auto', label: 'Autoflowerit' }
        ];
    var choicesWrap = wrap.querySelector('.sf-intro-choices');
    choices.forEach(function (c) {
      var count = c.v ? self.data.filter(function (n) { return n.type === c.v; }).length : self.data.length;
      var btn = el('<button class="sf-btn sf-btn-primary" type="button">' + c.label +
        ' <span class="sf-choice-count">' + count + '</span></button>');
      btn.addEventListener('click', function () { self.typeFilter = c.v; self.step = 0; self.render(); });
      choicesWrap.appendChild(btn);
    });
    this.root.appendChild(wrap);
  };

  SeedFinderApp.prototype.renderStep = function () {
    var self = this, Q = QUESTIONS[this.step];
    this.multiSel = Q.multi ? (this.answers[Q.id] || []).slice() : [];
    this.root.innerHTML = '';

    var head = el('<div class="sf-progress"></div>');
    head.innerHTML =
      '<div class="sf-progress-meta"><span>Kysymys <strong>' + (this.step + 1) + '</strong> / ' + QUESTIONS.length + '</span>' +
      '<span>' + Math.round((this.step) / QUESTIONS.length * 100) + '%</span></div>' +
      '<div class="sf-progress-track"><div class="sf-progress-fill" style="width:' + (this.step / QUESTIONS.length * 100) + '%"></div></div>';
    this.root.appendChild(head);

    var step = el('<div class="sf-step"></div>');
    step.innerHTML = '<h2 class="sf-q">' + esc(Q.q) + '</h2><p class="sf-q-help">' + esc(Q.help) + '</p>';
    var optsWrap = el('<div class="sf-options"></div>');

    Q.options.forEach(function (o) {
      var selected = Q.multi ? self.multiSel.indexOf(o.value) > -1 : self.answers[Q.id] === o.value;
      var btn = el(
        '<button class="sf-option' + (selected ? ' is-selected' : '') + '" type="button">' +
          '<span class="sf-option-icon">' + icon(o.icon) + '</span>' +
          '<span class="sf-option-body"><span class="sf-option-label">' + esc(o.label) + '</span>' +
          (o.sub ? '<span class="sf-option-sub">' + esc(o.sub) + '</span>' : '') + '</span>' +
          '<span class="sf-option-check">' + CHECK + '</span>' +
        '</button>');
      btn.addEventListener('click', function () {
        if (Q.multi) {
          var i = self.multiSel.indexOf(o.value);
          if (i > -1) self.multiSel.splice(i, 1); else self.multiSel.push(o.value);
          btn.classList.toggle('is-selected');
          next.disabled = false;
        } else {
          self.answers[Q.id] = o.value;
          self.step++;
          self.render();
        }
      });
      optsWrap.appendChild(btn);
    });
    step.appendChild(optsWrap);

    var nav = el('<div class="sf-nav"></div>');
    var back = el('<button class="sf-btn sf-btn-ghost" type="button">Takaisin</button>');
    back.addEventListener('click', function () { self.step--; self.render(); });
    nav.appendChild(back);
    nav.appendChild(el('<div class="sf-spacer"></div>'));

    var next = el('<button class="sf-btn sf-btn-primary" type="button">' +
      (this.step === QUESTIONS.length - 1 ? 'Näytä tulokset ' : 'Jatka ') + ARROW + '</button>');
    if (Q.multi) {
      next.addEventListener('click', function () {
        self.answers[Q.id] = self.multiSel.slice();
        self.step++; self.render();
      });
      nav.appendChild(next);
    } else {
      // Yksivalinta etenee klikkauksesta; tarjotaan "Ohita" jos ei pakollinen
      var skip = el('<button class="sf-btn sf-btn-ghost" type="button">Ohita</button>');
      skip.addEventListener('click', function () { delete self.answers[Q.id]; self.step++; self.render(); });
      nav.appendChild(skip);
    }
    step.appendChild(nav);
    this.root.appendChild(step);
    window.scrollTo && this.root.scrollIntoView && this.root.scrollIntoView({ block: 'nearest' });
  };

  SeedFinderApp.prototype.computeResults = function () {
    var self = this;
    var pool = this.typeFilter
      ? this.data.filter(function (n) { return n.type === self.typeFilter; })
      : this.data;
    var scored = pool.map(function (n) {
      var s = scoreStrain(n, self.answers);
      return { n: n, pct: s.pct, reasons: reasons(n, self.answers) };
    });
    scored.sort(function (a, b) {
      if (b.pct !== a.pct) return b.pct - a.pct;
      if (a.n.available !== b.n.available) return a.n.available ? -1 : 1;
      if (a.n.award !== b.n.award) return a.n.award ? -1 : 1;
      return b.n.yieldScore - a.n.yieldScore;
    });
    return scored;
  };

  SeedFinderApp.prototype.renderResults = function () {
    var self = this;
    this.root.innerHTML = '';
    var all = this.computeResults();
    var list = this.onlyInStock ? all.filter(function (r) { return r.n.available; }) : all;
    if (this.shown == null) this.shown = 4; // näytä ensin 4, sitten 12, lopuksi kaikki
    var top = list.slice(0, this.shown);

    var head = el('<div class="sf-step"></div>');
    var soldCount = all.filter(function (r) { return !r.n.available; }).length;
    head.innerHTML =
      '<div class="sf-results-head">' +
        '<h2 class="sf-q">Sinulle suositellut lajikkeet</h2>' +
        '<div class="sf-toolbar">' +
          '<label class="sf-switch"><input type="checkbox" id="sf-stock"' + (this.onlyInStock ? ' checked' : '') +
          '><span class="sf-switch-track"></span>Vain varastossa</label>' +
        '</div>' +
      '</div>' +
      '<p class="sf-results-sub">Parhaat osumat valikoimastamme, järjestettynä sopivuuden mukaan.' +
      (this.typeFilter === 'photo' ? ' Vain feminisoidut lajikkeet.' : '') +
      (this.typeFilter === 'auto' ? ' Vain autoflower-lajikkeet.' : '') +
      (soldCount && !this.onlyInStock ? ' ' + soldCount + ' loppuunmyytyä mukana.' : '') + '</p>';
    this.root.appendChild(head);

    head.querySelector('#sf-stock').addEventListener('change', function (e) {
      self.onlyInStock = e.target.checked; self.shown = 4; self.render();
    });

    var grid = null;
    if (!top.length) {
      this.root.appendChild(el('<div class="sf-empty">Ei osumia näillä ehdoilla. Kokeile poistaa varastorajaus tai aloita alusta.</div>'));
    } else {
      grid = el('<div class="sf-grid"></div>');
      top.forEach(function (r, i) { grid.appendChild(self.card(r, i === 0)); });
      this.root.appendChild(grid);
    }

    // "Näytä lisää" - portaittain 4 -> 12 -> kaikki, ilman koko näkymän uudelleenlatausta.
    if (grid && list.length > this.shown) {
      var moreWrap = el('<div class="sf-more"></div>');
      var moreBtn = el('<button class="sf-btn sf-btn-ghost" type="button"></button>');
      var setLabel = function () {
        var next = self.shown < 12 ? Math.min(12, list.length) : list.length;
        moreBtn.textContent = self.shown < 12 ? 'Näytä lisää tuloksia' : ('Näytä kaikki (' + list.length + ')');
        return next;
      };
      setLabel();
      moreBtn.addEventListener('click', function () {
        var end = self.shown < 12 ? Math.min(12, list.length) : list.length;
        list.slice(self.shown, end).forEach(function (r) { grid.appendChild(self.card(r, false)); });
        self.shown = end;
        if (self.shown >= list.length) moreWrap.remove(); else setLabel();
      });
      moreWrap.appendChild(moreBtn);
      this.root.appendChild(moreWrap);
    }

    var foot = el('<div class="sf-results-foot"></div>');
    var footActions = el('<div class="sf-foot-actions"></div>');

    if (list.length > 8) {
      var topBtn = el('<button class="sf-btn sf-btn-ghost" type="button">↑ Listan kärkeen</button>');
      topBtn.addEventListener('click', function () {
        self.root.scrollIntoView && self.root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
      footActions.appendChild(topBtn);
    }

    var restart = el('<button class="sf-btn sf-btn-ghost" type="button">↺ Aloita alusta</button>');
    restart.addEventListener('click', function () {
      self.answers = {}; self.multiSel = []; self.step = -1; self.typeFilter = self.lockType; self.onlyInStock = false; self.shown = null; self.render();
    });
    footActions.appendChild(restart);
    foot.appendChild(footActions);
    foot.appendChild(el('<p class="sf-disclaimer">Suositukset perustuvat antamiisi vastauksiin ja lajikkeiden ominaisuuksiin. Myymme kannabiksen siemeniä vain keräilijöille, geneettiseen säilytykseen ja koristeeksi. Tiedot, jotka tarjoamme kuten tuotto, haju tai maku jne. ilmoitetaan vain näiden ollessa tärkeitä tietoja keräilijöille sekä muille laillisiin tarkoituksiin siemeniä ostaville.</p>'));
    this.root.appendChild(foot);
    this.root.scrollIntoView && this.root.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  SeedFinderApp.prototype.card = function (r, isTop) {
    var n = r.n;
    var url = this.baseUrl + '/products/' + encodeURIComponent(n.handle);
    var typeLabel = n.type === 'auto' ? 'Autoflower' : 'Feminisoitu';
    var timeLabel = n.weeks
      ? (n.type === 'auto' ? '≈ ' + n.weeks.min + '–' + n.weeks.max + ' vk' : n.weeks.min + '–' + n.weeks.max + ' vk kukinta')
      : null;

    var specs = ['<span class="sf-spec">' + typeLabel + '</span>',
      '<span class="sf-spec">' + LEAN_LABEL[n.lean] + '</span>',
      '<span class="sf-spec">' + YIELD_LABEL[n.yieldScore] + '</span>'];
    if (timeLabel) specs.push('<span class="sf-spec">' + timeLabel + '</span>');

    var reasonHtml = r.reasons.map(function (x) { return '<span class="sf-reason">' + esc(x) + '</span>'; }).join('');

    var media = n.image
      ? '<img loading="lazy" src="' + esc(n.image) + '" alt="' + esc(n.title) + '" onerror="this.style.display=\'none\'">'
      : '';

    var card = el('<article class="sf-card' + (isTop ? ' is-top' : '') + '"></article>');
    card.innerHTML =
      '<div class="sf-card-media">' + media +
        '<span class="sf-match">Osuvuus ' + r.pct + '%</span>' +
        (isTop ? '<span class="sf-badge-top">' + STAR + 'Paras osuma</span>' : '') +
        (!n.available ? '<span class="sf-badge-sold">Loppuunmyyty</span>' : '') +
      '</div>' +
      '<div class="sf-card-body">' +
        '<div class="sf-card-vendor">' + esc(n.vendor) + '</div>' +
        '<div class="sf-card-title">' + esc(n.title) + '</div>' +
        '<div class="sf-specs">' + specs.join('') + '</div>' +
        (reasonHtml ? '<div class="sf-reasons">' + reasonHtml + '</div>' : '') +
        '<div class="sf-card-foot">' +
          '<div class="sf-price">' + formatPrice(n.price) + ' <small>alk.</small></div>' +
          '<a class="sf-card-cta" href="' + esc(url) + '" target="_blank" rel="noopener">Katso tuote ' + ARROW + '</a>' +
        '</div>' +
      '</div>';
    return card;
  };

  function formatPrice(p) {
    if (p == null) return '';
    var s = (Math.round(p * 100) / 100).toFixed(2).replace('.', ',');
    return '€' + s; // sama muoto kuin verkkosivuilla (symboli edessä)
  }

  /* ---------- Julkinen API --------------------------------------------- */
  var SeedFinder = {
    init: function (opts) {
      opts = opts || {};
      var mount = typeof opts.mount === 'string' ? document.querySelector(opts.mount) : opts.mount;
      if (!mount) { console.error('[SeedFinder] mount-elementtiä ei löytynyt'); return; }
      var strains = opts.strains || global.SEEDFINDER_STRAINS;

      var boot = function (data) {
        if (!data || !data.length) {
          mount.className = 'seedfinder';
          mount.innerHTML = '<div class="sf-state">Lajiketietoja ei löytynyt.</div>';
          return;
        }
        new SeedFinderApp(mount, data, opts);
      };

      if (strains) return boot(strains);

      // Standalone: hae data/strains.json
      mount.className = 'seedfinder';
      mount.innerHTML = '<div class="sf-state"><div class="sf-spinner"></div>Ladataan lajikkeita…</div>';
      var src = opts.dataUrl || 'data/strains.json';
      fetch(src).then(function (r) { return r.json(); }).then(boot).catch(function (e) {
        console.error('[SeedFinder]', e);
        mount.innerHTML = '<div class="sf-state">Lajikkeiden lataus epäonnistui.</div>';
      });
    },

    // Liittää napin (opts.trigger), joka avaa SeedFinderin modaalina.
    // Ottaa samat data-asetukset kuin init (strains/dataUrl, baseUrl, resultsCount).
    // Widget renderöidään vasta ensimmäisellä avauksella (lazy).
    attachModal: function (opts) {
      opts = opts || {};
      var triggerSel = typeof opts.trigger === 'string' ? opts.trigger : null;
      var triggerEl = (opts.trigger && typeof opts.trigger !== 'string') ? opts.trigger : null;
      if (!triggerSel && !triggerEl) { console.error('[SeedFinder] trigger puuttuu'); return; }

      var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

      var dialog = document.createElement('dialog');
      dialog.className = 'sf-modal';
      dialog.setAttribute('aria-label', opts.modalLabel || 'SeedFinder');
      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'sf-modal-close';
      closeBtn.setAttribute('aria-label', 'Sulje');
      closeBtn.innerHTML = CLOSE;
      var panel = document.createElement('div');
      panel.className = 'sf-modal-panel';
      var mount = document.createElement('div');
      panel.appendChild(mount);
      dialog.appendChild(closeBtn);
      dialog.appendChild(panel);
      document.body.appendChild(dialog);

      var booted = false, lastFocus = null;

      function boot() {
        if (booted) return;
        booted = true;
        var o = { mount: mount };
        for (var k in opts) {
          if (opts.hasOwnProperty(k) && k !== 'trigger' && k !== 'mount' && k !== 'modalLabel') o[k] = opts[k];
        }
        SeedFinder.init(o);
      }
      function cleanup() {
        document.documentElement.classList.remove('sf-modal-open');
        if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
      }
      function open(activator) {
        var af = activator || document.activeElement;
        lastFocus = (af && af !== document.body) ? af : (triggerEl || null);
        boot();
        document.documentElement.classList.add('sf-modal-open');
        if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); }
        else { dialog.classList.add('sf-modal--fallback'); dialog.setAttribute('open', ''); }
      }
      function close() {
        if (typeof dialog.close === 'function' && dialog.open) { dialog.close(); }
        else { dialog.removeAttribute('open'); }
        // Siivous suoraan eikä vain 'close'-eventin varassa (osa upotetuista
        // selaimista ei laukaise eventtiä). cleanup on idempotentti.
        cleanup();
      }

      if (triggerSel) {
        // Event-delegaatio capture-vaiheessa: kestää työkalurivin AJAX-uudelleenlatauksen,
        // toimii usealla napilla ja ehtii ennen teeman omia klikkikäsittelijöitä.
        document.addEventListener('click', function (e) {
          var t = e.target && e.target.closest ? e.target.closest(triggerSel) : null;
          if (t) { e.preventDefault(); e.stopPropagation(); open(t); }
        }, true);
      } else {
        triggerEl.addEventListener('click', function (e) { e.preventDefault(); open(triggerEl); });
      }
      closeBtn.addEventListener('click', close);
      dialog.addEventListener('close', cleanup);  // Esc tai dialog.close()
      dialog.addEventListener('cancel', cleanup); // varmistus Esc:lle
      dialog.addEventListener('click', function (e) {
        // Taustaklikkaus (paneelin ulkopuolelle) sulkee.
        var r = dialog.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) close();
      });

      return { open: open, close: close, dialog: dialog };
    }
  };

  global.SeedFinder = SeedFinder;
})(window);
